import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import FormControl from 'react-bootstrap/lib/FormControl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Loader from '../../Loader';
import messages from '../../../locale/messages';

import cs from '../../commonStyle.css';
import s from './Calendar.css';

class PromoCodeInput extends Component {
  static propTypes = {
    appliedPromoCode: PropTypes.string,
    isPromoApplied: PropTypes.bool,
    promoErrorMessage: PropTypes.string,
    isApplying: PropTypes.bool,
    onApply: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      promoInput: props.appliedPromoCode || '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appliedPromoCode !== this.props.appliedPromoCode) {
      this.setState({
        promoInput: this.props.appliedPromoCode || '',
      });
    }
  }

  handleInputChange = (event) => {
    this.setState({ promoInput: event.target.value });
  };

  handleApply = () => {
    this.props.onApply(this.state.promoInput);
  };

  handleRemove = () => {
    this.setState({ promoInput: '' });
    this.props.onRemove();
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { appliedPromoCode, isPromoApplied, promoErrorMessage, isApplying } = this.props;
    const { promoInput } = this.state;
    const isApplied = Boolean(appliedPromoCode && isPromoApplied);
    const hasError = Boolean(promoErrorMessage && !isApplied);

    return (
      <div className={cx(cs.spaceBottom3, s.promoCodeSection)}>
        <label className={cx(cs.commonMediumText, cs.fontWeightMedium, cs.spaceBottom2)}>
          <FormattedMessage {...messages.promoCode} />
        </label>
        <div className={s.promoCodeRow}>
          <FormControl
            type="text"
            value={promoInput}
            placeholder={formatMessage(messages.promoCodeHint)}
            onChange={this.handleInputChange}
            disabled={isApplying || isApplied}
            className={cx(cs.formControlInput, s.promoCodeInput)}
          />
          <Loader
            type="button"
            className={cx(cs.btnPrimary, s.promoCodeButton)}
            handleClick={isApplied ? this.handleRemove : this.handleApply}
            disabled={isApplying}
            show={isApplying}
            label={formatMessage(isApplied ? messages.promoRemove : messages.promoApply)}
          />
        </div>
        {isApplied && (
          <p className={cx(s.promoAppliedText, cs.spaceTop1)}>
            <FormattedMessage {...messages.promoApplied} />
          </p>
        )}
        {hasError && (
          <p className={cx(s.promoErrorText, cs.spaceTop1)}>{promoErrorMessage}</p>
        )}
      </div>
    );
  }
}

export default injectIntl(withStyles(s, cs)(PromoCodeInput));
